<div class="relative flex items-center">
  <span class="absolute inset-y-0 left-0 flex items-center pl-2">
    <span class="material-symbols-outlined text-gray-400">search</span>
  </span>
  <input
    type="text"
    placeholder="Search by Patient Name..."
    class="flex-grow pl-10 pr-10 py-3 border border-gray-300 rounded-md shadow-sm focus:outline-none placeholder:text-gray-400 focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
    data-cy="page-home-input-search"
    [value]="searchTerm"
    (input)="onSearchChange($event)"
    (keyup.esc)="clearSearch()"
  />
  @if (searchTerm) {
  <div class="absolute inset-y-0 right-0 flex items-center pr-2">
    <button (click)="clearSearch()" class="focus:outline-none cursor-pointer" data-cy="page-home-button-clearSearch">
      <span class="material-symbols-outlined text-gray-400 hover:text-gray-600 cursor-pointer">close</span>
    </button>
  </div>
  }
</div>
